var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SimpleLimitsService } from './../../api/simple-limits.service';
import { OnInit, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractPropertiesSearch } from './index';
var ApartmentSearchBaseComponent = /** @class */ (function (_super) {
    __extends(ApartmentSearchBaseComponent, _super);
    function ApartmentSearchBaseComponent(router, route, simpleLimitsService, injector, window) {
        var _this = _super.call(this, injector, window) || this;
        _this.route = route;
        _this.simpleLimitsService = simpleLimitsService;
        _this.window = window;
        _this.listingSelect = false;
        _this.propertyTypeSelect = false;
        return _this;
    }
    ApartmentSearchBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.forEach(function (data) {
            _this.validateRouteDataParams(data, ['simple_limits']);
            _this.simpleLimits = data.simple_limits;
        });
    };
    ApartmentSearchBaseComponent.prototype.onSubmit = function () {
        if (AbstractPropertiesSearch.propertySearch.listing === 'for_sale') {
            AbstractPropertiesSearch.propertySearch.for_sale = true;
            if (AbstractPropertiesSearch.propertySearch.to_let) {
                AbstractPropertiesSearch.propertySearch.to_let = false;
            }
        }
        else if (AbstractPropertiesSearch.propertySearch.listing === 'to_let') {
            AbstractPropertiesSearch.propertySearch.to_let = true;
            if (AbstractPropertiesSearch.propertySearch.for_sale) {
                AbstractPropertiesSearch.propertySearch.for_sale = false;
            }
        }
        if (!AbstractPropertiesSearch.propertySearch.property_type) {
            this.router.navigate(['/apartamente'], { queryParams: AbstractPropertiesSearch.propertySearch, fragment: 'list' });
        }
        else {
            this.router.navigate([AbstractPropertiesSearch.propertySearch.property_type], { queryParams: AbstractPropertiesSearch.propertySearch, fragment: 'list' });
        }
    };
    return ApartmentSearchBaseComponent;
}(AbstractPropertiesSearch));
export { ApartmentSearchBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/apartment-search-base.component.ts.pre-build-optimizer.js